;
define("pickup_in_store_store_selector_list_row.tpl", function(){});

